import { PageHeader } from "components";
import { Entry } from "contentful";
import { NextPage } from "next";
import { NewsletterSection, PressHeaderSection, PressList } from "sections";
import { INewsletterSectionFields, IPressItemFields } from "types";
import {
  fetchHeaderPress,
  getContentfulEntries,
} from "../utils/contentful-api";

const Press: NextPage<{
  headerPress: (IPressItemFields & { createdAt: string })[];
  press: (IPressItemFields & { createdAt: string })[];
  newsletter: INewsletterSectionFields[];
}> = ({ headerPress, press, newsletter }) => {
  return (
    <div>
      <PageHeader title="Press" />
      <PressHeaderSection featured={headerPress} />
      <PressList press={press} />
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};

export default Press;

export async function getStaticProps() {
  const headerPressRes = await fetchHeaderPress();
  const headerPress = headerPressRes.map((p: Entry<IPressItemFields>) => {
    return { ...p.fields, createdAt: p.sys.createdAt };
  });

  const press = await getContentfulEntries<IPressItemFields>("pressItem");

  const newsletter = await getContentfulEntries<INewsletterSectionFields>(
    "newsletterSection"
  );

  return {
    props: {
      headerPress,
      press,
      newsletter,
    },
  };
}
